export default "__VITE_ASSET__DZKDSnR$__"